var exports = {
  "k": "x9245d464--32784c--container",
};

module.exports = exports;
